import { EndUser } from "@/types/user";
import { env } from "@/lib/variantConfig";

export const startLogin = async (state?: any) => {
  const { scheme, host, authorizePath, clientId } = env.auth;
  const url = new URL(`${scheme}://${host}`);
  url.pathname = authorizePath;
  url.searchParams.append("response_type", "code");
  url.searchParams.append("client_id", clientId);
  url.searchParams.append("scope", "email");
  if (state) {
    url.searchParams.append("state", btoa(JSON.stringify(state)));
  }

  window.open(url.toString(), "_self");
};

export const startLogout = async () => {
  const { scheme, host, logoutPath, clientId, callbackUrlLogout } = env.auth;
  const url = new URL(`${scheme}://${host}`);
  url.pathname = logoutPath;
  url.searchParams.append("response_type", "code");
  url.searchParams.append("client_id", clientId);
  url.searchParams.append("scope", clientId);
  url.searchParams.append("redirect", callbackUrlLogout);

  window.open(url.toString(), "_self");
};

export const getUserValue = <T>(user: EndUser, property: string): T | null => {
  const propertyValue = user.end_user_property_values?.data.find(
    (prop) => prop.end_user_property?.title === property,
  );
  return propertyValue ? (propertyValue.value as T) : null;
};
